export default "__VITE_ASSET__843e129b__"